import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class EventProjectService {

  httpOptions = {
    headers:new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  formDataHttpOptions = {
    headers:new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    })
  }

  constructor(private http: HttpClient, private constant: Constant) {

  }

  getAll(): Observable<any> {
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/event-project', this.httpOptions);
  }

  // รายการ Gallery (event project + รูปถ่ายล่าสุด + จำนวนรูป)
  getGallery(): Observable<any> {
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/gallery', this.httpOptions);
  }

  // ลบรูปถ่ายทั้งหมดภายใต้ gallery/event หนึ่ง ๆ
  deleteGalleryImages(eventProjectId): Observable<any> {
    return this.http.delete<any>(
      this.constant.API_DOMAIN + '/api/v1/gallery/' + eventProjectId + '/images',
      this.httpOptions
    ).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }
  
  getById(id): Observable<any> {
    return this.http.get<any>(this.constant.API_DOMAIN + '/api/v1/event-project/'+id+"/all", this.httpOptions);
  }

  getPrintCodeUsages(printCodeId, page: number = 1, perPage: number = 10): Observable<any> {
    const params = `?page=${page}&per_page=${perPage}`;
    return this.http.get<any>(
      this.constant.API_DOMAIN + '/api/v1/event-project/print-code/' + printCodeId + '/usages' + params,
      this.httpOptions
    );
  }

  create(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/event-project', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  update(req): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/event-project-update', req,
    this.formDataHttpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  updateOrder(orders): Observable<any> {
    return this.http.post<any>(this.constant.API_DOMAIN + '/api/v1/event-project-update-order', { orders },
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  delete(id): Observable<any> {
    return this.http.delete<any>(this.constant.API_DOMAIN + '/api/v1/event-project/' + id,
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(e) {
  console.log(e);
  if(e.error && e.error.message) {
    return throwError(e.error.message);
  }
  return throwError('');
  }
}